import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Testids } from '@hweeks/kei-costs-ui-testids';
import { FaqItem, SectionLabel } from '../../design';
import { CtaBand } from './CtaBand';
import { FAQ_GROUPS } from './FaqPage.data';
import './faq.css';
import { AnalyticsEvent, ctaEvent } from '../../utils/analytics';
import { MKT } from './links';
import { MarketingLayout } from './MarketingLayout';
export default function FaqPage() {
    return /*#__PURE__*/ _jsxs(MarketingLayout, {
        testid: Testids.app.marketing.faqRoot,
        children: [
            /*#__PURE__*/ _jsxs("main", {
                className: "mk-faq",
                children: [
                    /*#__PURE__*/ _jsx(SectionLabel, {
                        k: "質問",
                        className: "mk-faq__label",
                        children: "FAQ"
                    }),
                    /*#__PURE__*/ _jsx("h1", {
                        className: "mk-faq__title",
                        children: "Questions shops ask"
                    }),
                    /*#__PURE__*/ _jsxs("p", {
                        className: "mk-faq__intro",
                        children: [
                            "Anything else?",
                            ' ',
                            /*#__PURE__*/ _jsx("a", {
                                href: MKT.bookCall,
                                ...ctaEvent(AnalyticsEvent.ctaBookCall, 'faq'),
                                children: "Book a call"
                            }),
                            "."
                        ]
                    }),
                    FAQ_GROUPS.map((g)=>/*#__PURE__*/ _jsxs("section", {
                            className: "mk-faq__group",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "mk-faq__group-head",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "mk-faq__group-k",
                                            children: g.k
                                        }),
                                        /*#__PURE__*/ _jsx("h2", {
                                            className: "mk-faq__group-name",
                                            children: g.name
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    children: g.qs.map((item)=>/*#__PURE__*/ _jsx(FaqItem, {
                                            q: item.q,
                                            size: "lg",
                                            children: item.a
                                        }, item.q))
                                })
                            ]
                        }, g.name))
                ]
            }),
            /*#__PURE__*/ _jsx(CtaBand, {
                title: "Didn’t see your question?",
                sub: "Request access as a dealership or as an individual and ask us anything about your setup, your exporter or your paperwork. We reply by email."
            })
        ]
    });
}
